import script from "./adminHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./adminHeader.vue?vue&type=script&setup=true&lang=js"

import "./adminHeader.vue?vue&type=style&index=0&id=777aae74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777aae74"]])

export default __exports__